// extracted by mini-css-extract-plugin
module.exports = {"closedMessageBody":"_2ABHSa50SnRdAJIH1lcfSi"};